export default {
  data(){
      return{
  cn: {
    /* ===================== INDUSTRY AREA TITLE ======================*/

      industry_area_title: "行业领域",
      industry_area_button: "查看相关案例",


      /* ===================== INDUSTRY AREA ======================*/
    industry_area: [
      {
        id: "film_television",
        title: "影视",
        text: `云翰虹章凭借着其深厚的技术积累和创新能力立足于影视制作技术的前沿，尤其在虚拟制片技术方面获得了广泛的认可。通过结合实时3D引擎、动作捕捉（Motion Capture）、LED屏幕背景（LED Volume）和摄像机追踪等的虚拟制片技术，我们的技术团队能够在实时环境中模拟和捕捉虚拟场景，高效而精确地控制场景、角色、灯光等拍摄元素，极大简化了传统制片过程中涉及的后期特效合成工作。这一技术帮助导演和摄影师更好地把握拍摄效果，提升工作效率与质量，并为观众带来更震撼的视觉体验。`,
        image: require('@/assets/img/IndustryArea/FilmTelevision_industryarea_edited.jpg'),
        link: { path: '/planAndCases', hash: '#film_television' }
      },
      {
        id: "culture_tour",
        title: "文化旅游",
        text: `云翰虹章在文化旅游行业的布局以科技创新为核心，致力于将先进的虚拟现实、增强现实和超写实CG技术应用于文旅项目中，通过技术手段提升文化体验。我们积极推动文化与科技的深度融合，打造沉浸式的夜游活动、互动展览和主题乐园等新型文旅形式，增强游客的参与感和体验感。同时，我们在项目策划、全流程技术支持和本地化运营等方面提供一站式解决方案，确保文旅项目的高品质落地和长期稳定运营。未来，云翰虹章将继续深耕文化旅游市场，探索多样化的合作模式，与各地合作伙伴携手创新，为文旅产业注入新活力，推动文化旅游体验的不断升级。`,
        image: require('@/assets/img/IndustryArea/CultureTour_industryarea_edited.jpg'),
        link: { path: '/planAndCases', hash: '#culture_tour' }
      },
      {
        id: "digital_assets",
        title: "数字资产",
        text: `在数字资产领域，云翰虹章的技术团队通过先进的3D建模、CG动画和虚拟现实技术，将物理空间和实体资产数字化呈现，以便客户更有效地进行品牌宣传、教育推广和客户体验提升。我们的技术团队使用虚幻引擎，结合正向建模和逆向建模方法，高效制作高精度的3D模型。我们的数字资产业务，适用于工业、教育和文化等领域的多样化需求，能够应对高精度和复杂项目的要求，为客户提供虚拟展览、产品演示和教育展示等个性化解决方案。`,
        image: require('@/assets/img/IndustryArea/DigitalAssets.jpg'),
        link: { path: '/planAndCases', hash: '#digital_assets' }
      },
      {
        id: "aigc",
        title: "AIGC",
        text: `云翰虹章在AIGC领域的版图涵盖了AI绘图、AI摄影和虚拟数字人等多项技术，充分应用了人工智能在视觉创作和人机交互方面的强大能力。我们的技术团队利用深度学习和生成对抗网络（GAN），实现了高质量的图像生成，既具有艺术性又高度逼真。我们推出的虚拟数字人则结合自然语言处理（NLP）和情感识别技术，外形精美，具备自然的语言交互和情感反馈能力，为用户提供个性化的互动体验。通过这些技术的深度融合，云翰虹章在AIGC领域构建了完整且强大的技术生态，推动了人工智能在多领域的创新应用。`,
        image: require('@/assets/img/IndustryArea/AIGC_industryarea_edited.png'),
        link: { path: '/planAndCases', hash: '#aigc' }
      }
    ],
    
  }
}
}
};
